import addServiceClicked from "../events/add-service-clicked.js";
import serviceDeleted from "../events/service-deleted.js";
import serviceCreated from "../events/service-created.js";
import serviceUpdated from "../events/service-updated.js";
import servicesReordered from "../events/services-reordered.js";
import reorderBtnClicked from "../events/reorder-btn-clicked.js";
function makeEventRouter() {
    const router = {
        'add-service-clicked': addServiceClicked,
        'reorder-btn-clicked': reorderBtnClicked
    };
    const routerWithData = {};
    const formRouterWithData = {
        'form-created': serviceCreated,
        'form-updated': serviceUpdated,
        'form-deleted': serviceDeleted,
        'entities-reordered': servicesReordered
    };
    return Object.freeze({
        get,
        getWithData,
        getFormActionWithData
    });
    function get(action) {
        return router[action];
    }
    function getWithData(action) {
        return routerWithData[action];
    }
    function getFormActionWithData(action) {
        return formRouterWithData[action];
    }
}
;
const APP_VIEWS = makeEventRouter();
export default APP_VIEWS;
